'use strict';

function error(instance, message, statusCode, errorCode, data) {
  instance.statusCode = statusCode;
  instance.message = message || 'Unknown Error';
  instance.code = errorCode;
  instance.data = data;
  if (Error.captureStackTrace) {
    //only supported in v8
    Error.captureStackTrace(instance, instance.constructor);
  }
  return instance;
}
function setPrototype(Sub, Sup) {
  var name = Sub.name;
  Sub.prototype = new Sup();
  Sub.prototype.constructor = Sub;
  Sub.prototype.name = name;
}
function PlatformError() {
  return error(this);
}
setPrototype(PlatformError, Error);
function NotFoundError(message, code, data) {
  return error(this, message, 404, code, data);
}
setPrototype(NotFoundError, PlatformError);
function UnknownError(message, code, data) {
  return error(this, message, 500, code, data);
}
setPrototype(UnknownError, PlatformError);
function NotAuthorizedError(message, code, data) {
  return error(this, message, 401, code, data);
}
setPrototype(NotAuthorizedError, PlatformError);
function ForbiddenError(message, code, data) {
  return error(this, message, 403, code, data);
}
setPrototype(ForbiddenError, PlatformError);
function BadRequestError(message, code, data) {
  return error(this, message, 400, code, data);
}
setPrototype(BadRequestError, PlatformError);
function TimeoutError(message, code, data) {
  return error(this, message, 504, code, data);
}
setPrototype(TimeoutError, PlatformError);
function ConflictError(message, code, data) {
  return error(this, message, 409, code, data);
}
setPrototype(ConflictError, PlatformError);
function ProtoError(message, code, data) {
  return error(this, message, 422, code, data);
}
setPrototype(ProtoError, PlatformError);
function ExpiredError(message, code, data) {
  return error(this, message, 410, code, data);
}
setPrototype(ExpiredError, PlatformError);
function UnprocessableEntityError(message, code, data) {
  return error(this, message, 422, code, data);
}
setPrototype(UnprocessableEntityError, PlatformError);
var errors = {
  PlatformError: PlatformError,
  NotFoundError: NotFoundError,
  NotAuthorizedError: NotAuthorizedError,
  ForbiddenError: ForbiddenError,
  BadRequestError: BadRequestError,
  TimeoutError: TimeoutError,
  ConflictError: ConflictError,
  UnknownError: UnknownError,
  ProtoError: ProtoError,
  ExpiredError: ExpiredError,
  UnprocessableEntityError: UnprocessableEntityError
};
function deserialize(string) {
  var createError = function createError(_ref) {
    var message = _ref.message,
      name = _ref.name,
      code = _ref.code,
      data = _ref.data;
    var ErrorType = errors[name] || errors.UnknownError;
    return new ErrorType(message, code, data);
  };
  try {
    return createError(JSON.parse(string));
  } catch (err) {
    return createError({
      message: string
    });
  }
}
function serialize(err) {
  return JSON.stringify({
    message: err.message,
    name: err.name,
    code: err.code,
    data: err.data
  });
}
errors.utils = {
  serialize: serialize,
  deserialize: deserialize
};
module.exports = errors;